var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-params space-y-4"},[(_vm.deviceType === 'event')?[_c('DeviceAlertParams',{model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})]:[_c('div',{staticClass:"text-muted-foreground"},[_vm._v("Please select a device type.")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }